import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  viewChild,
} from '@angular/core';

import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select } from '../../models/Select';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { FormControlErrorsPipe } from 'src/app/core/pipes/form-control-errors-pipe/form-control-errors.pipe';
import { map, startWith } from 'rxjs/operators';
import { AngularMaterialModule } from '../../angular-material.module';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

/**
 * @deprecated Angular Material autocomplete, kept only until TCDS provides an autocomplete.
 * Do not add new usages.
 */
@Component({
  selector: 'mytc-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    FormControlErrorsPipe,
    AngularMaterialModule,
    AsyncPipe,
    FormsModule,
  ],
})
export class AutocompleteInputComponent implements OnInit, OnChanges {
  @Input() control: FormControl;
  @Input() inputId: string;
  @Input() label: string;
  @Input() formControlPlacehoder?: string;
  @Input() autocompleteValues: Select[];
  @Input() showAutocompleteButton = false;
  @Input() showDefaultErrors = true;
  @Input() additionalErrorDisplayCondition: boolean;

  @Output() autocompleteSearchChange = new EventEmitter<string>();

  @Output() autocompleteValueChanged = new EventEmitter<string>();

  readonly autocompleteTrigger = viewChild<MatAutocompleteTrigger>('autocompleteTrigger');

  filteredValuesForAutocomplete$;
  showAutocomplete = false;

  ngOnInit(): void {
    this.filteredValuesForAutocomplete$ = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterValue(value || '')),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !!changes['autocompleteValues'] &&
      this.showAutocompleteButton &&
      !changes['autocompleteValues'].isFirstChange()
    ) {
      this.autocompleteTrigger()?.openPanel();
    }
  }

  updatedAutocomplete(event): void {
    if (event.length >= 1) {
      this.showAutocomplete = true;
    } else {
      this.showAutocomplete = false;
    }
  }

  onAutocompleteValueChange(value: string): void {
    this.autocompleteValueChanged.emit(value);
  }

  onAutocompleteSearchChange(event: MouseEvent): void {
    this.autocompleteSearchChange.emit(this.control.value);

    event.stopPropagation();
  }

  private filterValue(value: string): Select[] {
    const valueToBeFiltered = value.toLowerCase();
    return this.autocompleteValues?.filter((option) => option.label.toLowerCase().includes(valueToBeFiltered));
  }
}
